<template>
  <div style="height: 700px">
    <div
      style="height: 110px; display: flex; justify-content: space-around; align-items: center; font-size: 24px; font-weight: bold; text-align: center;">
      <div @click="tapcarworklist('ON_SITE_CARS')">
        <div>{{statistics.onSite}}</div>
        <div>在厂</div>
      </div>
      <div @click="tapworklist('RUN')">
        <div>{{statistics.running}}</div>
        <div>施工</div>
      </div>
      <div @click="tapworklist('WAIT')">
        <div>{{statistics.waiting}}</div>
        <div>待修</div>
      </div>
    </div>
    <div class="van-hairline--top"></div>
    <div style="display: flex; justify-content: space-around; text-align: right">
      <div>
        <div class="item" @click="tapworklist('TO_DELIVER')">
          <label>待交车</label><label class="number">{{statistics.toDelivery}}</label>
        </div>
        <div class="item" @click="tapcarworklist('OVERDUE_CARS')">
          <label>超时交车</label><label class="number">{{statistics.overdue}}</label>
        </div>
        <div class="item" @click="tapcarworklist('DELAY_CARS')">
          <label>延迟交车</label><label class="number">{{statistics.delay}}</label>
        </div>
        <div class="item" @click="tapcarworklist('REWORK_CARS')">
          <label>返工车辆</label><label class="number">{{statistics.reworked}}</label>
        </div>
        <div class="item" @click="tapcarworklist('INTERRUPT_CARS')">
          <label>中断车辆</label><label class="number">{{statistics.interrupted}}</label>
        </div>
        <div v-for="(procedure, index) of dispatchableProceduresQuality" class="item" :key="index" @click="tapworkOneArray(procedure[0].workList)">
            <label>质检</label><label class="number">{{procedure[0].workList.length}}</label>
        </div>
      </div>
      <div>
        <div class="item" @click="tapworklist('DELIVERED')">
          <label>待结算</label><label class="number">{{statistics.toSettle}}</label>
        </div>
        <div class="item" @click="tapcarworklist('TODAY_CARS')">
          <label>今日进厂</label><label class="number">{{statistics.enterToday}}</label>
        </div>
        <div class="item" @click="tapcarworklist('DUE_TODAY_CARS')">
          <label>今日应交</label><label class="number">{{statistics.dueToday}}</label>
        </div>
        <div class="item" @click="tapcarworklist('TODAY_DELIVERY_CARS')">
          <label>今日已交</label><label class="number">{{statistics.todayDelivery}}</label>
        </div>
        <div class="item" @click="tapcarworklist('DUE_TOMORROW_CARS')">
          <label>明日应交</label><label class="number">{{statistics.dueTomorrow}}</label>
        </div>
        <div v-for="(procedure, index) of dispatchableProceduresCarWash" class="item" :key="index" @click="tapworkOneArray(procedure[0].workList)">
          <label>洗车</label><label class="number">{{procedure[0].workList.length}}</label>
        </div>
      </div>
    </div>

    <div style="font-size: 20px; margin: 6px 30px 0 30px">工序详情</div>
    <div style="display: flex; justify-content: space-around">
      <div style="text-align: right">
        <div class="item">工序</div>
        <div v-for="(procedure, index) of dispatchableProcedures" class="item" :key="index">
          {{procedure[0].name.split('/')[0]}}
        </div>
      </div>
      <div style="text-align: center; color: orange; font-weight: bold">
        <div style="margin: 16px auto; color: black; font-weight: normal">待修</div>
        <div v-for="(procedure, index) of dispatchableProcedures" class="item" :key="index" @click="tapworkArray('WAIT',procedure[1].workList)">
          {{procedure[1].workList.length}}
        </div>
      </div>
      <div style="text-align: center; color: orange; font-weight: bold">
        <div style="margin: 16px auto; color: black; font-weight: normal">施工</div>
        <div v-for="(procedure, index) of dispatchableProcedures" class="item" :key="index" @click="tapworkArray('RUN',procedure[0].workList)">
          {{procedure[0].workList.length}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { statisticsDataMixin } from '@/views/mixins/StatisticsData'

  export default {
    name: 'WxKanban',
    mixins: [statisticsDataMixin],
    computed: {
      dispatchableProcedures () {
        return this.$store.state.work.middleWorks
          .filter(procedure => procedure[0].dispatchable)
      },
      dispatchableProceduresQuality () {
        return this.$store.state.work.middleWorks
          .filter(procedure => procedure[0].name === '质检' && procedure[0].type === 'QUALITY')
      },
      dispatchableProceduresCarWash () {
        return this.$store.state.work.middleWorks
          .filter(procedure => procedure[0].name === '洗车' && procedure[0].type === 'CAR_WASH')
      }
    },
    methods: {
        tapcarworklist (val) {
            const url = this.$route.query
            this.$router.push({ path: '/wx_main', query: { openid: url.openid, active: '1', carstater: val } })
            this.$router.go(0)
        },
        tapworklist (val) {
            const url = this.$route.query
            this.$router.push({ path: '/wx_main', query: { openid: url.openid, active: '1', stater: val } })
            this.$router.go(0)
        },
        tapworkArray (val, item) {
            if (item.length <= 0) return
            const url = this.$route.query
            this.$router.push({ path: '/wx_main', query: { openid: url.openid, active: '1', stater: val, itemprocedureId: item[0].procedureId } })
            this.$router.go(0)
        },
        tapworkOneArray (item) { // 特殊工序：质检、洗车等
            if (item.length <= 0) return
            const url = this.$route.query
            this.$router.push({ path: '/wx_main', query: { openid: url.openid, active: '1', itemprocedureId: item[0].procedureId } })
            this.$router.go(0)
        }
    }
  }
</script>

<style lang="scss" scoped>

  .number {
    margin-left: 10px;
    color: orange;
    font-weight: bold
  }

  .item {
    margin: 16px auto;
    height: 22px;
    line-height: 22px;
  }
</style>
